var validity;
var message;

var lineItemQuantity = $('#shopify-section-cart-template .quantity').map(function() {
    return $(this).data('product-id');
});

var uniqueProductId = $.unique(lineItemQuantity);

$(uniqueProductId).each(function(i, v){
  
  var productIDTotalQuantity = 0;
  
  $('#shopify-section-cart-template .quantity.product_id_' + v).each(function(){
  	productIDTotalQuantity = productIDTotalQuantity + +$(this).val();
  });
  
  var productRemainingQuantity = $('#shopify-section-cart-template .quantity.product_id_' + v).data('tag-remaining');
  
  var productTitle = $('#shopify-section-cart-template .quantity.product_id_' + v).data('product-title').replace('- Concession Price','').replace('- Full Price','');
  
  
  if(productIDTotalQuantity > productRemainingQuantity){
  	validity = 'invalid';
    message = '<p style="color:red;font-style:italic;font-size:14px;"> we are sorry there are only ' + productRemainingQuantity.toString() + ' places left on course ' + productTitle + ' and you are trying to purchase ' + productIDTotalQuantity.toString() + '</p>';    
    $('#shopify-section-cart-template .quantity.product_id_' + v).parents('li').find('.title_column').append(message);
  }
  

});

if(validity === 'invalid'){
	$('#shopify-section-cart-template p.add-to-cart-wrap').remove();
    $('#shopify-section-cart-template div.tos_checkbox').remove();
    $('#shopify-section-cart-template div.additional-checkout-buttons').remove();
}

